import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Wave 3.5 — shared page header for golden-path / admin surfaces.
 * Brand-adjacent display type + one supporting line; actions optional.
 */
export function TastePageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <Box
      className="taste-rise"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
        pb: 2,
        borderBottom:
          '1px solid color-mix(in srgb, var(--outline-variant) 55%, transparent)',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="h4"
          component="h1"
          className="font-display"
          sx={{
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: 'var(--primary-navy)',
            fontFamily: 'var(--font-display)',
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body2"
            sx={{
              mt: 0.75,
              maxWidth: 640,
              color: 'var(--on-surface-variant)',
              lineHeight: 1.55,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            alignItems: 'center',
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
